import type { ReactNode } from 'react';
import { Botao } from './Botao.js';
import { PainelLateral } from './PainelLateral.js';
import './FormularioLateral.css';

type Props = {
  readonly titulo: ReactNode;
  readonly subtitulo?: ReactNode;
  readonly rotuloConfirmar: string;
  readonly rotuloCancelar?: string;
  /** Chamado no envio: pelo botão e pelo Enter em qualquer campo. */
  readonly aoConfirmar: () => void;
  readonly aoFechar: () => void;
  /** Bloqueia a confirmação enquanto a escrita não voltou do middleware. */
  readonly enviando?: boolean;
  /** Falha já traduzida (`api/erros.ts`). O formulário continua aberto. */
  readonly erro?: string;
  readonly children: ReactNode;
};

/**
 * Cadastro e edição em painel lateral.
 *
 * O supervisor não perde a tabela de vista ao abrir um formulário — por isso
 * é painel, e não navegação. A falha do middleware aparece dentro do próprio
 * painel: fechar o formulário perderia o que a pessoa digitou, que é
 * exatamente o que ela precisa corrigir.
 */
export function FormularioLateral({
  titulo,
  subtitulo,
  rotuloConfirmar,
  rotuloCancelar = 'Cancelar',
  aoConfirmar,
  aoFechar,
  enviando = false,
  erro,
  children,
}: Props) {
  function confirmar() {
    // Enquanto a escrita não voltou do middleware, o envio não repete: dois
    // Enter seguidos gravariam dois cadastros.
    if (!enviando) {
      aoConfirmar();
    }
  }

  return (
    <PainelLateral titulo={titulo} subtitulo={subtitulo} aoFechar={aoFechar}>
      <form
        className="formulario-lateral"
        noValidate
        onSubmit={(evento) => {
          evento.preventDefault();
          confirmar();
        }}
      >
        <div className="formulario-lateral__campos">{children}</div>

        {erro !== undefined && (
          <p className="formulario-lateral__erro" role="alert">
            {erro}
          </p>
        )}

        <div className="formulario-lateral__rodape">
          <Botao variante="secundario" onClick={aoFechar} disabled={enviando}>
            {rotuloCancelar}
          </Botao>
          <Botao variante="primario" type="submit" disabled={enviando}>
            {enviando ? 'Salvando…' : rotuloConfirmar}
          </Botao>
        </div>
      </form>
    </PainelLateral>
  );
}
